import * as R from 'ramda'

import { hasEqualShape } from '@collector/shared-utils'
import { Incident } from '@collector/sportsapi-client'
import { IncidentId } from '@collector/sportsapi-client-legacy'

/**
 * Config for grouping two related incidents into one History block.
 * `incidentIds` is `[substitutionOutId, substitutionInId]`.
 */
export type IncidentIdsGroup = {
  name: string
  incidentIds: [IncidentId, IncidentId]
}

export function isIncidentIdsGroup(
  value: IncidentId | IncidentIdsGroup,
): value is IncidentIdsGroup {
  return R.is(Object, value)
}

/**
 * Complete groups store incidents as `[SubstitutionIn, SubstitutionOut]`.
 */
export type IncidentsGroup = {
  name: string
  incidents: [Incident] | [Incident, Incident]
}

export function isIncidentsGroup(
  value: Incident | IncidentsGroup,
): value is IncidentsGroup {
  return hasEqualShape(
    {
      name: String,
      incidents: Array,
    },
    value as IncidentsGroup,
  )
}

/**
 * Returns the incident used for header metadata (time, team, sorting).
 */
export function getIncidentsGroupRepresentativeIncident(
  group: IncidentsGroup,
): Incident {
  return group.incidents.length === 2 ? group.incidents[1] : group.incidents[0]
}
